import axios from 'axios';
import { createMutation, createQuery } from 'react-query-kit';

import { restUrl } from '@/services/utils';
import { ServerErrorResponse } from '@/types/ServerErrorResponse';

import { ItemsSearchFilter } from './FilterBuilder.types';

const END_POINT = 'filterProfiles';

const useFilterProfiles = createQuery<ItemsSearchFilter[], void, Error>({
    queryKey: [END_POINT],
    fetcher: async () => {
        const response = await axios.get<ItemsSearchFilter[]>(restUrl(END_POINT));
        return response.data ?? [];
    },
});

const useSaveFilterProfile = createMutation<ItemsSearchFilter, ItemsSearchFilter, ServerErrorResponse>({
    mutationFn: async (filter) => {
        const response = await axios.post<ItemsSearchFilter>(restUrl(END_POINT), filter);
        return response.data;
    },
});

const useDeleteFilterProfile = createMutation<unknown, { identifier: string }, ServerErrorResponse>({
    mutationFn: async ({ identifier }) => {
        const response = await axios.delete(restUrl(`${END_POINT}/${encodeURIComponent(identifier)}`));
        return response.data;
    },
});

export { useDeleteFilterProfile, useFilterProfiles, useSaveFilterProfile };
